import axios from 'axios'

function authHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchPartnerApplyStatus() {
  const res = await axios.get('/api/v1/partner/apply/status', { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || null
}

export async function submitPartnerApply(payload) {
  const res = await axios.post('/api/v1/partner/apply/submit', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '提交失败')
  return res.data.data
}

export async function submitWithdrawApply(payload) {
  const res = await axios.post('/api/v1/withdraw/apply/submit', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '提交失败')
  return res.data.data
}

export async function fetchWithdrawApplyList({ page = 1, pageSize = 20 } = {}) {
  const res = await axios.post('/api/v1/withdraw/apply/list', { page, pageSize }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function fetchMyCreations({ page = 1, pageSize = 20 } = {}) {
  const res = await axios.post('/api/v1/creator/my-creations', { page, pageSize }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { exams: [], courses: [], examTotal: 0, courseTotal: 0 }
}

export async function fetchCreatorIncome({ page = 1, pageSize = 20 } = {}) {
  const res = await axios.post('/api/v1/creator/income/list', { page, pageSize }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function fetchUserMessages({ page = 1, pageSize = 20, source = '', isRead = -1 } = {}) {
  const res = await axios.get('/api/v1/user/messages/list', {
    headers: authHeaders(),
    params: { page, pageSize, source: source || undefined, isRead }
  })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function fetchUnreadMessageCount() {
  const res = await axios.get('/api/v1/user/messages/unread', { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return Number(res.data.data?.unread || 0)
}

export const UNREAD_MESSAGES_CHANGED_EVENT = 'unread-messages-changed'

export function notifyUnreadMessagesChanged({ unread, delta } = {}) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(UNREAD_MESSAGES_CHANGED_EVENT, {
    detail: { unread, delta }
  }))
}

export async function markMessagesRead(ids = []) {
  const res = await axios.post('/api/v1/user/messages/read', { ids }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '标记已读失败')
  if (!ids || ids.length === 0) {
    notifyUnreadMessagesChanged({ unread: 0 })
  } else {
    notifyUnreadMessagesChanged({ delta: -ids.length })
  }
  return true
}

const MESSAGE_SOURCE_LABELS = {
  profile: '资料审核',
  idcard: '实名认证',
  exam: '测评',
  course: '课程',
  blog: '编辑推荐',
  moment: '动态',
  like: '喜欢',
  comment: '评论',
  recharge: '充值',
  withdraw: '提现',
  referral: '推荐礼遇',
  inquiry: '意见留言',
  purchase_refund: '购买申诉',
  system: '系统',
  knowledge: '知识库',
  知识库: '知识库',
  知识库反馈: '知识库反馈',
  审核通过: '审核',
  审核不通过: '审核',
  零钱充值通知: '充值',
  零钱充值余额通知: '充值',
  提现失败: '提现',
  提现成功: '提现',
  入账通知: '入账'
}

export function messageSourceLabel(source) {
  const key = String(source || '').trim()
  if (!key) return '系统'
  return MESSAGE_SOURCE_LABELS[key] || MESSAGE_SOURCE_LABELS[key.toLowerCase()] || key
}

/** 实名与提现页共用：是否已通过实名、审核中等 */
export async function fetchUserVerificationBrief() {
  const uuid = localStorage.getItem('uuid') || ''
  const res = await axios.post('/api/v1/user/myprofile/get', { uuid }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载用户信息失败')
  const profile = res.data.data || {}
  return {
    isVerified: Number(profile.isVerified) === 1,
    vipLevel: profile.vip_level || 0
  }
}

/** 预填提现户名等 */
export async function fetchIdCardProfile() {
  const res = await axios.post('/api/v1/idcard/verify/get', {}, { headers: authHeaders() })
  if (res.data?.code !== 200) return null
  const data = res.data.data || {}
  return {
    realName: data.effective_name || data.name || '',
    idCardNumber: data.effective_idcard || data.idcard || '',
    idCardFront: data.idcard_front || '',
    idCardBack: data.idcard_back || '',
    auditStatus: Number(data.audit_status) || 0,
    failReason: data.fail_reason || '',
    isVerified: Number(data.is_verified) === 1
  }
}

export function referralStatementExportUrl() {
  const token = localStorage.getItem('jwt_token')
  return `/api/v1/referral/export/statement?token=${encodeURIComponent(token || '')}`
}

export async function fetchAdminPartnerApplications(params) {
  const res = await axios.post('/api/v1/admin/partner/applications/list', params, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function reviewPartnerApplication(payload) {
  const res = await axios.post('/api/v1/admin/partner/applications/review', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '处理失败')
  return res.data.data
}

export async function fetchAdminWithdrawApplications(params) {
  const res = await axios.post('/api/v1/admin/withdraw/applications/list', params, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function reviewWithdrawApplication(payload) {
  const res = await axios.post('/api/v1/admin/withdraw/applications/review', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '处理失败')
  return res.data.data
}

export function adminWithdrawExportUrl() {
  const token = localStorage.getItem('jwt_token')
  return `/api/v1/admin/withdraw/export?token=${encodeURIComponent(token || '')}`
}

export const PARTNER_STATUS_LABELS = {
  pending: '审核中',
  approved: '已通过',
  rejected: '已拒绝'
}

export const WITHDRAW_STATUS_LABELS = {
  pending: '待审核',
  approved: '已通过待打款',
  rejected: '已拒绝',
  paid: '已打款'
}
